/**
 * Preferable not use it as it's slow AF
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pepKeys',
})
export class PepKeysPipe implements PipeTransform {

  transform(value, args: string[]): any {
    if (!value) { return value; }

    const keepKeys = false; // TODO: Add arg
    let keys = [];

    Object.keys(value).forEach((key) => {
      if (value.hasOwnProperty(key)) {
        if (!keepKeys) {
          keys = [...keys, value[key]];
        } else {
          keys = [...keys, { key, value: value[key] }];
        }
      }
    });

    return keys;
  }

}
